import {DraggingStyle, NotDraggingStyle} from 'react-beautiful-dnd';

const getItemStyle = (isDragging: boolean, draggableStyle: DraggingStyle | NotDraggingStyle | undefined) => ({
  border: isDragging ? '1px dashed #404040' : '',
  ...draggableStyle,
});

export default getItemStyle;
